// extracted by mini-css-extract-plugin
export var originalPrice = "_ts-0";